import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
  errorText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, hasError, errorText, ...props }, ref) => (
    <>
      <input
        ref={ref}
        className={cn(
          "text-ink-900 placeholder:text-ink-400 focus:ring-gold-400 h-11 w-full rounded-md border bg-white px-3 text-sm transition-colors focus:ring-2 focus:outline-none disabled:opacity-50",
          hasError || errorText
            ? "border-danger focus:ring-danger"
            : "border-ink-200",
          className,
        )}
        {...props}
      />
      {errorText && <p className="text-danger mt-1 text-sm">{errorText}</p>}
    </>
  ),
);
Input.displayName = "Input";
